import React, { Component } from "react";
import "./bed.css";

import BedMap from './BedMap'


export default class Bed extends Component{
  constructor(props) {
    super(props);
     this.state = { counter: 0 };




  }

  componentDidMount(){
  }

  componentDidUpdate(){
  }


  render(){


      return(<div>
        <h2>
        {this.props.data.P?(<span>Bed:Person present</span>):(<span>Bed</span>)}
        {this.props.data.L?(<span className="redtext">:Outside Limit</span>):(<span></span>)}
        <span>:{((this.props.data.W)/1000).toFixed(1)} Kg</span>
        </h2>
        <div class="flexed">
        <span>{new Date().toLocaleTimeString()}</span>
        <div>
        <table className="castorTable">
        <tr><td>Weight</td><td>{this.props.data.W} g</td></tr>
        <tr><td>R1</td><td>{this.props.data.R1/10}</td></tr>
        <tr><td>R2</td><td>{this.props.data.R2/10}</td></tr>
        <tr><td>R3</td><td>{this.props.data.R3/10}</td></tr>
        <tr><td>R4</td><td>{this.props.data.R4/10}</td></tr>
        <tr><td>Present</td><td>{this.props.data.P}</td></tr>
        <tr><td>Limit</td><td>{this.props.data.L}</td></tr>
        <tr><td>X</td><td>{this.props.data.X}</td></tr>
        <tr><td>Y</td><td>{this.props.data.Y}</td></tr>
        <tr><td>SD</td><td>{this.props.data.SD}</td></tr>
        <tr><td>Version</td><td>{this.props.data.v}</td></tr>
        </table>
        </div><div >
        <BedMap x={this.props.data.X} y={this.props.data.Y}></BedMap>



        </div>
        </div>

        </div>

      )

  }
}



// WEBPACK FOOTER //
// ./src/programmerComponents/Bed.js